import React from 'react';
import { CalendarDays, CheckCircle2, Hourglass, Send } from 'lucide-react';
import { StatTile } from '../components/StatTile';
import { EventCard } from '../components/EventCard';
import { CreateEventDialog } from '../components/CreateEventDialog';
import { useEvents } from '../contexts/EventsContext';
import { summarizeInvitations } from '../utils/event';
export function EventsList() {
  const {
    events
  } = useEvents();
  const totals = events.map(summarizeInvitations).reduce((acc, s) => ({
    total: acc.total + s.total,
    accepted: acc.accepted + s.accepted,
    declined: acc.declined + s.declined,
    awaiting: acc.awaiting + s.awaiting
  }), {
    total: 0,
    accepted: 0,
    declined: 0,
    awaiting: 0
  });
  const responded = totals.accepted + totals.declined;
  const acceptance = responded ? Math.round(totals.accepted / responded * 100) : 0;
  const sorted = [...events].sort((a, b) => a.date.localeCompare(b.date));
  return <main className="mx-auto max-w-7xl px-4 py-8 sm:px-6 lg:px-8" data-id="element-759" data-mp="3mg45009zxt3o">
      <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between" data-id="element-760" data-mp="3b2gzgrfjfodo">
        <div className="flex items-center gap-4" data-id="element-761" data-mp="371nbjy23i9ks">
          <span className="flex size-12 items-center justify-center rounded-xl bg-primary text-primary-foreground" data-id="element-762" data-mp="3krqtwdxutj4y">
            <CalendarDays className="size-6" aria-hidden="true" data-id="element-763" data-mp="3g0ik3gsm3vr9" />
          </span>
          <div data-id="element-764" data-mp="3upwsomod695l">
            <h1 className="text-2xl font-semibold tracking-tight" data-id="element-765" data-mp="3upez5xt3691d">Events</h1>
            <p className="text-sm text-muted-foreground" data-id="element-766" data-mp="3pqu041pklvei">Organize BAK events and invite experts to take part.</p>
          </div>
        </div>
        <CreateEventDialog data-id="element-767" data-mp="7k5wyhe2zibh" />
      </div>

      <section aria-label="Events summary" className="mt-6 grid grid-cols-2 gap-3 lg:grid-cols-4" data-id="element-768" data-mp="7j4h7zm4e7nf">
        <StatTile label="Upcoming events" value={String(events.length)} icon={CalendarDays} data-id="element-769" data-mp="2k1b0buelvdv" />
        <StatTile label="Invitations sent" value={String(totals.total)} icon={Send} data-id="element-770" data-mp="29eocxhruerk9" />
        <StatTile label="Awaiting reply" value={String(totals.awaiting)} icon={Hourglass} data-id="element-771" data-mp="24f22fg3efpf5" />
        <StatTile label="Acceptance rate" value={`${acceptance}%`} hint={`${totals.accepted} of ${responded} replies`} icon={CheckCircle2} data-id="element-772" data-mp="8bx7vrkzst0w" />
      </section>

      <section aria-label="Event list" className="mt-8 grid gap-4 md:grid-cols-2 xl:grid-cols-3" data-id="element-773" data-mp="i80lpup7ig3o">
        {sorted.map(ev => <EventCard key={ev.id} event={ev} data-id="element-774" data-mp="mawy33o5lfz6" />)}
      </section>
    </main>;
}